import * as yup from 'yup'

export const UpdateReportSchema = yup.object().shape({
    report_name: yup.string().required('Report name is required'),
    priority: yup
        .number()
        .typeError('Priority must be a number')
        .min(0)
        .max(10)
        .optional(),
    domains: yup.array().of(yup.string()).optional(),
    service_customer_id: yup.string().max(50).optional().nullable(),
    domain_source: yup.string().oneOf(['elastic', 'history', '']).optional(),
    send_format: yup
        .string()
        .oneOf(['default', 'DetailOriented', ''])
        .optional(),
    provider: yup.string().oneOf(['mlytics', 'conversant', '']).optional(),
    report_engine: yup.string().oneOf(['v1', 'v2', '']).optional(),
    service_id: yup
        .number()
        .typeError('Service ID must be a number')
        .integer()
        .positive()
        .nullable()
        .optional()
        // Cosmetic guard: submit handler is the definitive check.
        // _requireBinding is a hidden form field synced from onMeta.
        .test(
            'binding-required',
            'Vui lòng chọn service — khách hàng này có nhiều nhóm mailer nên phải gán service để gửi đúng người nhận.',
            function (value) {
                const { _requireBinding } = this.parent as {
                    _requireBinding?: boolean
                }
                if (_requireBinding && (value == null || value === undefined)) {
                    return false
                }
                return true
            }
        ),
    _requireBinding: yup.boolean().optional().default(false),
})
